import { NavDropdownProps } from './_NavDropdown';
import { isNavDropdown, SecondaryNavProps } from './_SecondaryNav';
import { Anchor } from '@repo/ui/src/components/Anchor';
import ChevronIcon from '@repo/ui/src/components/Icons/ChevronIcon';
import { navigationClicked } from '@repo/ui/src/services/analytics';
import { StateSetterFunction } from '@repo/ui/src/types/helpers';
import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';

export interface MobileSecondaryNavProps extends SecondaryNavProps {
  activeDropdown: NavDropdownProps | null;
  setActiveDropdown: StateSetterFunction<NavDropdownProps | null>;
}

const MobileSecondaryNav = ({
  items,
  activeDropdown,
  setActiveDropdown,
  primaryHeader,
}: MobileSecondaryNavProps) => {
  return (
    <div role="region" aria-label={`${primaryHeader} submenu`}>
      <ul
        className={classNames(
          'tw-list-none tw-grid tw-gap-x-8 sm:tw-flex sm:tw-justify-center tw-px-0',
        )}
        aria-label="main"
      >
        {items?.map((item, i) => {
          const hasDropdown = isNavDropdown(item);
          return (
            <li key={i} className="tw-px-4 sm:tw-px-0">
              {!hasDropdown ? (
                <Anchor
                  {...item}
                  className={classNames(
                    'tw-inline-block tra-text-web-body-l hover:tw-text-brand-400 hover:tw-underline tw-transition-all tw-duration-300 tw-py-6',
                  )}
                  onClick={() =>
                    navigationClicked({
                      nav_type: 'Top Navigation',
                      clicked_text: item?.displayName ?? '',
                      primary_header: primaryHeader ?? '',
                      secondary_header: item?.displayName ?? '',
                    })
                  }
                />
              ) : (
                <button
                  onClick={() => {
                    setActiveDropdown(item);
                    navigationClicked({
                      nav_type: 'Top Navigation',
                      clicked_text: item?.title ?? '',
                      primary_header: primaryHeader ?? '',
                      secondary_header: item?.title ?? '',
                    });
                  }}
                  className={classNames(
                    'tra-text-web-body-l tw-flex tw-justify-between tw-w-full sm:tw-w-auto sm:tw-block hover:tw-text-brand-400 hover:tw-underline tw-transition-all tw-duration-300 tw-py-6',
                  )}
                  aria-expanded={activeDropdown === item}
                  aria-haspopup="true"
                  aria-controls="mobile-tertiary-nav"
                >
                  {item.title}
                  <span className="tw-w-6 tw-inline-block sm:tw-hidden" aria-hidden="true">
                    <ChevronIcon direction="right" />
                  </span>
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MobileSecondaryNav;
